export const hairTransplantPrices = {
  de: [
    { name: "FUE Haartransplantation (bis 5.000 Grafts)", price: "1.500 – 2.000", stay: "Day Hospital / 2 Tage Hotel (3 Tage)" },
  ],
  en: [
    { name: "FUE Hair Transplant (up to 5,000 Grafts)", price: "1,500 – 2,000", stay: "Day Hospital / 2 days Hotel (3 days)" },
  ],
  fr: [
    { name: "Greffe de Cheveux FUE (jusqu'à 5 000 Greffons)", price: "1.500 – 2.000", stay: "Hôpital de jour / 2 jours Hôtel (3 jours)" },
  ],
  it: [
    { name: "Trapianto di Capelli FUE (fino a 5.000 Innesti)", price: "1.500 – 2.000", stay: "Day Hospital / 2 giorni Albergo (3 giorni)" },
  ],
  sq: [
    { name: "Transplant flokësh FUE (deri në 5.000 graft)", price: "1.500 – 2.000", stay: "Spital ditor / 2 ditë hotel (3 ditë)" },
  ],
};

export const dentalPrices = {
  de: [
    { name: "Zahnimplantat", price: "350 – 400" },
    { name: "Zirkonkrone", price: "170 – 220" },
    { name: "Keramikkrone", price: "140" },
    { name: "Unsichtbare Zahnspange", price: "2.000 – 2.500" },
    { name: "Professionelle Zahnreinigung", price: "50" },
    { name: "Zahnaufhellung", price: "120 – 150" },
    { name: "Kleiner Knochenaufbau", price: "250" },
    { name: "Großer Knochenaufbau", price: "550" },
    { name: "Sinus Lift", price: "400" },
    { name: "Pterygoid-Implantat", price: "850" },
    { name: "Zygomatisches Implantat", price: "1.000 – 1.200" },
    { name: "Elastische Prothese", price: "1.000" },
  ],
  en: [
    { name: "Dental Implant", price: "350 – 400" },
    { name: "Zirconia Crown", price: "170 – 220" },
    { name: "Ceramic Crown", price: "140" },
    { name: "Invisible Braces", price: "2.000 – 2.500" },
    { name: "Cleaning", price: "50" },
    { name: "Whitening", price: "120 – 150" },
    { name: "Small Bone Graft", price: "250" },
    { name: "Large Bone Graft", price: "550" },
    { name: "Sinus Lift", price: "400" },
    { name: "Pterygoid Implant", price: "850" },
    { name: "Zygomatic Implant", price: "1.000 – 1.200" },
    { name: "Elastic Denture", price: "1.000" },
  ],
  fr: [
    { name: "Implante Dentaire", price: "350 – 400" },
    { name: "Couronne en Zircone", price: "170 – 220" },
    { name: "Couronne en Céramique", price: "140" },
    { name: "Appareil Invisible", price: "2.000 – 2.500" },
    { name: "Nettoyage Dentaire", price: "50" },
    { name: "Blanchiment", price: "120 – 150" },
    { name: "Greffe Osseuse Petite", price: "250" },
    { name: "Greffe Osseuse Grande", price: "550" },
    { name: "Sinus Lift", price: "400" },
    { name: "Implant Ptérygoïdien", price: "850" },
    { name: "Implant Zygomatique", price: "1.000 – 1.200" },
    { name: "Prothèse Élastique", price: "1.000" },
  ],
  it: [
    { name: "Impianto Dentale", price: "350 – 400" },
    { name: "Corona in Zirconio", price: "170 – 220" },
    { name: "Corona in Ceramica", price: "140" },
    { name: "Apparecchio Invisibile", price: "2.000 – 2.500" },
    { name: "Pulizia", price: "50" },
    { name: "Sbiancamento", price: "120 – 150" },
    { name: "Innesto Osseo Piccolo", price: "250" },
    { name: "Innesto Osseo Grande", price: "550" },
    { name: "Sinus Lift", price: "400" },
    { name: "Impianto Pterigoideo", price: "850" },
    { name: "Impianto Zigomatico", price: "1.000 – 1.200" },
    { name: "Protesi Elastica", price: "1.000" },
  ],
  sq: [
    { name: "Implant dentar", price: "350 – 400" },
    { name: "Kurorë zirkoni", price: "170 – 220" },
    { name: "Kurorë qeramike", price: "140" },
    { name: "Aparat dhëmbësh i padukshëm", price: "2.000 – 2.500" },
    { name: "Pastrim profesional i dhëmbëve", price: "50" },
    { name: "Zbardhim dhëmbësh", price: "120 – 150" },
    { name: "Mbushje e vogël kockore", price: "250" },
    { name: "Mbushje e madhe kockore", price: "550" },
    { name: "Ngritje sinusi", price: "400" },
    { name: "Implant pterigoid", price: "850" },
    { name: "Implant zigomatik", price: "1.000 – 1.200" },
    { name: "Protezë elastike", price: "1.000" },
  ],
};

export const surgeryPrices = {
  de: [
    { name: "Bauchdeckenstraffung", price: "4.500", stay: "2 Nächte KH / 4 Tage Hotel (6 Tage)" },
    { name: "Nasenkorrektur", price: "2.200", stay: "1 Nacht KH / 2 Tage Hotel (3 Tage)" },
    { name: "Nasenkorrektur + Septumkorrektur", price: "2.500", stay: "1 Nacht KH / 3 Tage Hotel (4 Tage)" },
    { name: "Nasenkorrektur Revision", price: "2.800", stay: "1 Nacht KH / 3 Tage Hotel (4 Tage)" },
    { name: "Ohrkorrektur", price: "1.600", stay: "Day Hospital / 2 Tage Hotel (3 Tage)" },
    { name: "Unterlidstraffung", price: "1.800", stay: "Day Hospital / 2 Tage Hotel (3 Tage)" },
    { name: "Oberlidstraffung", price: "1.600", stay: "Day Hospital / 2 Tage Hotel (3 Tage)" },
    { name: "Komplette Lidstraffung", price: "2.600", stay: "Day Hospital / 2 Tage Hotel (3 Tage)" },
    { name: "Brustvergrößerung (Mentor)", price: "4.200", stay: "2 Nächte KH / 4 Tage Hotel (6 Tage)" },
    { name: "Brustverkleinerung", price: "5.000 – 6.500", stay: "2 Nächte KH / 5 Tage Hotel (7 Tage)" },
    { name: "Facelifting", price: "4.200", stay: "2 Nächte KH / 5 Tage Hotel (7 Tage)" },
    { name: "Facelifting (Mentor)", price: "5.000", stay: "2 Nächte KH / 5 Tage Hotel (7 Tage)" },
    { name: "Gynäkomastie", price: "3.500", stay: "1 Nacht KH / 5 Tage Hotel (6 Tage)" },
    { name: "Bauchdeckenstraffung + Liposuktion", price: "5.000", stay: "1 Nacht KH / 7 Tage Hotel (8 Tage)" },
    { name: "Liposuktion + BBL", price: "5.500", stay: "1 Nacht KH / 5 Tage Hotel (6 Tage)" },
    { name: "Liposuktion (1 Zone)", price: "2.500", stay: "1 Nacht KH / 4 Tage Hotel (5 Tage)" },
    { name: "Liposuktion (Total Body)", price: "5.000", stay: "1 Nacht KH / 7 Tage Hotel (8 Tage)" },
    { name: "Gesichtslifting", price: "6.500", stay: "1 Nacht KH / 7 Tage Hotel (8 Tage)" },
    { name: "Oberarmstraffung", price: "4.000 – 5.000", stay: "1 Nacht KH / 6 Tage Hotel (7 Tage)" },
    { name: "Oberschenkelstraffung", price: "5.500 – 6.000", stay: "1 Nacht KH / 6 Tage Hotel (7 Tage)" },
    { name: "Magenballon", price: "2.500 – 3.000", stay: "Total (2 Tage)" },
  ],
  en: [
    { name: "Abdominoplasty", price: "4.500", stay: "2 nights hospital / 4 days hotel (6 days)" },
    { name: "Rhinoplasty", price: "2.200", stay: "1 night hospital / 2 days hotel (3 days)" },
    { name: "Rhinoplasty + Septoplasty", price: "2.500", stay: "1 night hospital / 3 days hotel (4 days)" },
    { name: "Rhinoplasty Revision", price: "2.800", stay: "1 night hospital / 3 days hotel (4 days)" },
    { name: "Otoplasty", price: "1.600", stay: "Day hospital / 2 days hotel (3 days)" },
    { name: "Lower Eyelid Surgery", price: "1.800", stay: "Day hospital / 2 days hotel (3 days)" },
    { name: "Upper Eyelid Surgery", price: "1.600", stay: "Day hospital / 2 days hotel (3 days)" },
    { name: "Total Eyelid Surgery", price: "2.600", stay: "Day hospital / 2 days hotel (3 days)" },
    { name: "Breast Augmentation (Mentor)", price: "4.200", stay: "2 nights hospital / 4 days hotel (6 days)" },
    { name: "Breast Reduction", price: "5.000 – 6.500", stay: "2 nights hospital / 5 days hotel (7 days)" },
    { name: "Facelift", price: "4.200", stay: "2 nights hospital / 5 days hotel (7 days)" },
    { name: "Facelift (Mentor)", price: "5.000", stay: "2 nights hospital / 5 days hotel (7 days)" },
    { name: "Gynecomastia", price: "3.500", stay: "1 night hospital / 5 days hotel (6 days)" },
    { name: "Abdominoplasty + Liposuction", price: "5.000", stay: "1 night hospital / 7 days hotel (8 days)" },
    { name: "Liposuction + BBL", price: "5.500", stay: "1 night hospital / 5 days hotel (6 days)" },
    { name: "Liposuction (1 Zone)", price: "2.500", stay: "1 night hospital / 4 days hotel (5 days)" },
    { name: "Liposuction (Total Body)", price: "5.000", stay: "1 night hospital / 7 days hotel (8 days)" },
    { name: "Face Lift", price: "6.500", stay: "1 night hospital / 7 days hotel (8 days)" },
    { name: "Arm Lift", price: "4.000 – 5.000", stay: "1 night hospital / 6 days hotel (7 days)" },
    { name: "Thigh Lift", price: "5.500 – 6.000", stay: "1 night hospital / 6 days hotel (7 days)" },
    { name: "Gastric Balloon", price: "2.500 – 3.000", stay: "Total (2 days)" },
  ],
  fr: [
    { name: "Abdominoplastie", price: "4.500", stay: "2 nuits hôpital / 4 jours hôtel (6 jours)" },
    { name: "Rhinoplastie", price: "2.200", stay: "1 nuit hôpital / 2 jours hôtel (3 jours)" },
    { name: "Rhinoplastie + Déviation", price: "2.500", stay: "1 nuit hôpital / 3 jours hôtel (4 jours)" },
    { name: "Rhinoplastie Révision", price: "2.800", stay: "1 nuit hôpital / 3 jours hôtel (4 jours)" },
    { name: "Otoplastie", price: "1.600", stay: "Hospitalisation de jour / 2 jours hôtel (3 jours)" },
    { name: "Blépharoplastie Inférieure", price: "1.800", stay: "Hospitalisation de jour / 2 jours hôtel (3 jours)" },
    { name: "Blépharoplastie Supérieure", price: "1.600", stay: "Hospitalisation de jour / 2 jours hôtel (3 jours)" },
    { name: "Blépharoplastie Totale", price: "2.600", stay: "Hospitalisation de jour / 2 jours hôtel (3 jours)" },
    { name: "Augmentation Mammaire (Mentor)", price: "4.200", stay: "2 nuits hôpital / 4 jours hôtel (6 jours)" },
    { name: "Réduction Mammaire", price: "5.000 – 6.500", stay: "2 nuits hôpital / 5 jours hôtel (7 jours)" },
    { name: "Lifting", price: "4.200", stay: "2 nuits hôpital / 5 jours hôtel (7 jours)" },
    { name: "Lifting (Mentor)", price: "5.000", stay: "2 nuits hôpital / 5 jours hôtel (7 jours)" },
    { name: "Gynécomastie", price: "3.500", stay: "1 nuit hôpital / 5 jours hôtel (6 jours)" },
    { name: "Abdominoplastie + Liposuccion", price: "5.000", stay: "1 nuit hôpital / 7 jours hôtel (8 jours)" },
    { name: "Liposuccion + BBL", price: "5.500", stay: "1 nuit hôpital / 5 jours hôtel (6 jours)" },
    { name: "Liposuccion (1 Zone)", price: "2.500", stay: "1 nuit hôpital / 4 jours hôtel (5 jours)" },
    { name: "Liposuccion (Corps Total)", price: "5.000", stay: "1 nuit hôpital / 7 jours hôtel (8 jours)" },
    { name: "Lifting Visage", price: "6.500", stay: "1 nuit hôpital / 7 jours hôtel (8 jours)" },
    { name: "Lifting Bras", price: "4.000 – 5.000", stay: "1 nuit hôpital / 6 jours hôtel (7 jours)" },
    { name: "Lifting Cuisses", price: "5.500 – 6.000", stay: "1 nuit hôpital / 6 jours hôtel (7 jours)" },
    { name: "Ballon Gastrique", price: "2.500 – 3.000", stay: "Total (2 jours)" },
  ],
  it: [
    { name: "Addominoplastica", price: "4.500", stay: "2 notti ospedale / 4 giorni albergo (6 giorni)" },
    { name: "Rinoplastica", price: "2.200", stay: "1 notte ospedale / 2 giorni albergo (3 giorni)" },
    { name: "Rinoplastica + Deviazione", price: "2.500", stay: "1 notte ospedale / 3 giorni albergo (4 giorni)" },
    { name: "Rinoplastica Revisione", price: "2.800", stay: "1 notte ospedale / 3 giorni albergo (4 giorni)" },
    { name: "Otoplastica", price: "1.600", stay: "Day hospital / 2 giorni albergo (3 giorni)" },
    { name: "Blefaroplastica Inf.", price: "1.800", stay: "Day hospital / 2 giorni albergo (3 giorni)" },
    { name: "Blefaroplastica Sup.", price: "1.600", stay: "Day hospital / 2 giorni albergo (3 giorni)" },
    { name: "Blefaroplastica Totale", price: "2.600", stay: "Day hospital / 2 giorni albergo (3 giorni)" },
    { name: "Aumento del Seno (Mentor)", price: "4.200", stay: "2 notti ospedale / 4 giorni albergo (6 giorni)" },
    { name: "Riduzione del Seno", price: "5.000 – 6.500", stay: "2 notti ospedale / 5 giorni albergo (7 giorni)" },
    { name: "Lifting", price: "4.200", stay: "2 notti ospedale / 5 giorni albergo (7 giorni)" },
    { name: "Lifting (Mentor)", price: "5.000", stay: "2 notti ospedale / 5 giorni albergo (7 giorni)" },
    { name: "Ginecomastia", price: "3.500", stay: "1 notte ospedale / 5 giorni albergo (6 giorni)" },
    { name: "Addominoplastica + Liposuzione", price: "5.000", stay: "1 notte ospedale / 7 giorni albergo (8 giorni)" },
    { name: "Liposuzione + BBL", price: "5.500", stay: "1 notte ospedale / 5 giorni albergo (6 giorni)" },
    { name: "Liposuzione (1 Zona)", price: "2.500", stay: "1 notte ospedale / 4 giorni albergo (5 giorni)" },
    { name: "Liposuzione (Total Body)", price: "5.000", stay: "1 notte ospedale / 7 giorni albergo (8 giorni)" },
    { name: "Face Lifting", price: "6.500", stay: "1 notte ospedale / 7 giorni albergo (8 giorni)" },
    { name: "Lifting Braccia", price: "4.000 – 5.000", stay: "1 notte ospedale / 6 giorni albergo (7 giorni)" },
    { name: "Lifting Gambe", price: "5.500 – 6.000", stay: "1 notte ospedale / 6 giorni albergo (7 giorni)" },
    { name: "Balon Gastric", price: "2.500 – 3.000", stay: "Tot (2 giorni)" },
  ],
  sq: [
    { name: "Abdominoplastikë", price: "4.500", stay: "2 net spital / 4 ditë hotel (6 ditë)" },
    { name: "Rinoplastikë", price: "2.200", stay: "1 natë spital / 2 ditë hotel (3 ditë)" },
    { name: "Rinoplastikë + Korrigjim septumi", price: "2.500", stay: "1 natë spital / 3 ditë hotel (4 ditë)" },
    { name: "Rinoplastikë Rishikim", price: "2.800", stay: "1 natë spital / 3 ditë hotel (4 ditë)" },
    { name: "Otoplastikë", price: "1.600", stay: "Spital ditor / 2 ditë hotel (3 ditë)" },
    { name: "Operacion i qepallës së poshtme", price: "1.800", stay: "Spital ditor / 2 ditë hotel (3 ditë)" },
    { name: "Operacion i qepallës së sipërme", price: "1.600", stay: "Spital ditor / 2 ditë hotel (3 ditë)" },
    { name: "Operacion i plotë i qepallave", price: "2.600", stay: "Spital ditor / 2 ditë hotel (3 ditë)" },
    { name: "Zmadhim gjiri (Mentor)", price: "4.200", stay: "2 net spital / 4 ditë hotel (6 ditë)" },
    { name: "Zvogëlim gjiri", price: "5.000 – 6.500", stay: "2 net spital / 5 ditë hotel (7 ditë)" },
    { name: "Lifting i fytyrës", price: "4.200", stay: "2 net spital / 5 ditë hotel (7 ditë)" },
    { name: "Lifting i fytyrës (Mentor)", price: "5.000", stay: "2 net spital / 5 ditë hotel (7 ditë)" },
    { name: "Ginekomasti", price: "3.500", stay: "1 natë spital / 5 ditë hotel (6 ditë)" },
    { name: "Abdominoplastikë + Liposuksion", price: "5.000", stay: "1 natë spital / 7 ditë hotel (8 ditë)" },
    { name: "Liposuksion + BBL", price: "5.500", stay: "1 natë spital / 5 ditë hotel (6 ditë)" },
    { name: "Liposuksion (1 zonë)", price: "2.500", stay: "1 natë spital / 4 ditë hotel (5 ditë)" },
    { name: "Liposuksion (Trup i plotë)", price: "5.000", stay: "1 natë spital / 7 ditë hotel (8 ditë)" },
    { name: "Lifting i fytyrës", price: "6.500", stay: "1 natë spital / 7 ditë hotel (8 ditë)" },
    { name: "Lifting i krahëve", price: "4.000 – 5.000", stay: "1 natë spital / 6 ditë hotel (7 ditë)" },
    { name: "Lifting i kofshëve", price: "5.500 – 6.000", stay: "1 natë spital / 6 ditë hotel (7 ditë)" },
    { name: "Balonë gastrike", price: "2.500 – 3.000", stay: "Gjithsej (2 ditë)" },
  ],
};